const Blocker = ({ blockerProps }) => {
  return <div>{blockerProps.content}</div>;
};

export default Blocker;
